import { useScrollAnimation, useStaggerAnimation } from '../../../hooks/useScrollAnimation';

export default function Features() {
  const features = [
    { icon: 'ri-medal-line', title: 'Mais de 25 Anos de Experiência', description: 'Expertise consolidada em gestão de riscos e contratação profissional de seguros para empresas e pessoas físicas.' },
    { icon: 'ri-hand-coin-line', title: 'Economia Média de 35%', description: 'Negociação estratégica com seguradoras garante redução significativa nos prêmios sem perder cobertura.' },
    { icon: 'ri-shield-check-line', title: 'Análise Técnica Completa', description: 'Diagnóstico profundo dos seus riscos e coberturas para garantir proteção adequada ao seu patrimônio.' },
    { icon: 'ri-customer-service-2-line', title: 'Suporte em Sinistros', description: 'Acompanhamento técnico especializado para garantir indenizações justas e processos ágeis.' },
    { icon: 'ri-line-chart-line', title: 'Gestão Estratégica', description: 'Revisões periódicas e otimização contínua para manter o melhor custo-benefício sempre.' },
    { icon: 'ri-team-line', title: 'Atendimento Personalizado', description: 'Cada cliente recebe estratégia customizada baseada em suas necessidades e perfil de risco.' }
  ];

  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation();
  const { ref: gridRef, visibleItems } = useStaggerAnimation(features.length);

  return (
    <section className="py-16 sm:py-20 lg:py-28 bg-white" aria-labelledby="features-heading">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        <div
          ref={headerRef as React.RefObject<HTMLDivElement>}
          className={`text-center mb-12 sm:mb-16 transition-all duration-700 ease-out ${headerVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <div className="inline-flex items-center gap-2 bg-strategic-green-100 px-4 py-2 rounded-full mb-4 sm:mb-6" aria-hidden="true">
            <i className="ri-star-line text-strategic-green-700 text-base"></i>
            <span className="text-strategic-green-800 font-bold text-xs sm:text-sm uppercase tracking-wide">Diferenciais</span>
          </div>
          <h2 id="features-heading" className="text-3xl sm:text-4xl lg:text-5xl font-bold text-petrol-900 mb-4 sm:mb-6 px-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Por Que Escolher a{' '}
            <span className="text-strategic-green-600">IBX Brasil</span>
          </h2>
          <p className="text-base sm:text-lg text-petrol-800 max-w-3xl mx-auto leading-relaxed px-4">
            Combinamos experiência, metodologia profissional e relacionamento estratégico com seguradoras para entregar <strong className="text-petrol-900">resultados reais</strong> aos nossos clientes.
          </p>
        </div>

        <div ref={gridRef as React.RefObject<HTMLDivElement>} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {features.map((feature, index) => (
            <article
              key={index}
              className={`bg-gradient-to-br from-petrol-50 to-white rounded-xl sm:rounded-2xl p-6 sm:p-8 shadow-lg hover:shadow-2xl border border-petrol-100 hover:border-strategic-green-400 group transition-all duration-700 ease-out ${visibleItems[index] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
            >
              <div className="w-14 h-14 bg-gradient-to-br from-strategic-green-500 to-strategic-green-600 rounded-xl flex items-center justify-center mb-4 sm:mb-6 group-hover:scale-110 transition-transform" aria-hidden="true">
                <i className={`${feature.icon} text-2xl sm:text-3xl text-white`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-petrol-900 mb-3 sm:mb-4 leading-tight">{feature.title}</h3>
              <p className="text-sm sm:text-base text-petrol-800 leading-relaxed">{feature.description}</p>
            </article>
          ))}
        </div>

      </div>
    </section>
  );
}
